module.exports = __webpack_public_path__ + "img/team4.aa63776b.jpg";